import { Grid, Layout, Spinner } from '@enterprise-ui/canvas-ui-react'

export const LoadingPage = () => {
  return (
    <>
      <Layout.Body includeRail>
        <Grid.Container style={{ height: 'calc(100vh - 56px)' }}>
          <Grid.Item className="hesp-general-fullwidth hesp-general-flex">
            <Spinner
              className="hesp-general-marginAuto hesp-general-justifyCenter"
              size="expanded"
            />
          </Grid.Item>
        </Grid.Container>
      </Layout.Body>
    </>
  )
}
